/**
 * Makes a 3-number CVV
 * @param {string} value
 * @param {object} obj
 * @param {number} obj.max
 * @example
 * returns "123"
 */
const normalizeCardCVV = (
  value: string,
  { max }: { max: number } = { max: 3 },
): string => {
  return (
    value
      /** remove all non-digits */
      .replace(/\D+/g, "")
      /** only 3 digits max */
      .substring(0, max)
  );
};

export default normalizeCardCVV;
